import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { FiTarget, FiUser, FiCpu, FiActivity } from "react-icons/fi";
import ModuleHeader from "../../moduleHeader";
import {
    getCurrentPackageUserModule,
    calculateHumanChart,
    getLatestHumanChart
} from "../../../services/api";
import { jsPDF } from "jspdf";
import domtoimage from "dom-to-image-more";
import { FiShare2, FiDownload } from "react-icons/fi";
import { toast } from "react-toastify";
import HumanDesignMap from "./HumanDesignMap";
import HumanDesignAnalysis from "./HumanDesignAnalysis";

const CENTER_NAMES_TR = {
    Head: 'Kafa Merkezi',
    Ajna: 'Ajna Merkezi',
    Throat: 'Boğaz Merkezi',
    G: 'G Merkezi',
    Ego: 'Ego Merkezi',
    Sacral: 'Sakral Merkezi',
    Root: 'Kök Merkezi',
    Spleen: 'Dalak Merkezi',
    Solar: 'Solar Pleksus'
};

const PLANET_SYMBOLS = {
    Sun: "☉", Earth: "⊕", Moon: "☽", North_Node: "☊", South_Node: "☋",
    Mercury: "☿", Venus: "♀", Mars: "♂", Jupiter: "♃", Saturn: "♄",
    Uranus: "♅", Neptune: "♆", Pluto: "♇"
};

const MAP_DATA = {
    COLORS: {
        HEAD: '#F9F0A0', AJNA: '#99D5CA', THROAT: '#C0A08C', G: '#F9F0A0',
        EGO: '#F2A6A6', SACRAL: '#F2A6A6', SPLEEN: '#C0A08C', SOLAR: '#C0A08C',
        ROOT: '#C0A08C', UNDEFINED: '#FFFFFF', DESIGN: '#DC2626', PERSONALITY: '#1F2937'
    },
    SVG_PATHS: {
        FIGURE: "M671.25,720.333c65.375-9.208,139.079-31.648,174.117-78.966c16.881-22.798,28.908-71.182,24.447-81.59c-5.669-14.687-12.07-18.102-41.12-12.717c-15.263,2.493-45.825-2.943-46.283-29.05c1.443-21.161,3.351-77.706-2.598-86.628c-5.948-8.922-25.356-11.331-23.87-21.74C757.432,399.234,787.812,340.841,788,329c0.342-11.055-10.485-25.269-14.176-29.8c-0.701-0.861-1.308-2.242-1.308-2.242s-0.447-1.587-0.411-2.653c0.353-10.534,3.855-69.289,39.709-123.306c47.271-71.216,126.082-72.703,163-72.703c31.227,0,114.516-5.073,179,72.703c87.732,105.736,22,227.669-18,297c-40.653,70.464-34.601,135.015-5.182,173.367c51.63,67.306,140.211,75.574,177.034,79.299c6.29,0.775,30.712,2.604,42,10.667c14,10,19.035,27.878,21,32.333c33.599,81.192,250.128,602.245,311.976,760.714c9.01,24.849,14.156,42.028,13.288,54.655c-1.088,15.818-10.16,31.84-21.706,44.259c-255.071,280.326-426.6,344.511-686.225,344.511l-0.22,0.005c-258.299,0-438.955-66.053-685.481-344.145c-10.958-12.36-20.065-29.441-20.555-45.333c-0.033-1.062-2.509-18.369,9.915-48.615c65.989-163.213,263.609-628.923,322.634-766.192c10.524-24.476,24.68-31.761,24.832-31.859C645.625,727.5,653.981,723.124,671.25,720.333z",
        HEAD: "M1122.594,193.576c19.709,30.77,3.73,55.714-35.688,55.715l-80.596,0.004c-9.854,0-25.832,0-35.687,0l-80.596-0.004c-39.418-0.001-55.396-24.945-35.688-55.715l40.295-62.911c4.927-7.692,12.915-20.163,17.843-27.855l40.301-62.907c19.711-30.769,51.668-30.769,71.379,0l40.3,62.907c4.928,7.692,12.917,20.163,17.844,27.855L1122.594,193.576z",
        AJNA: "M854.339,356.152c-19.708-30.77-3.729-55.714,35.688-55.715l80.596-0.003c9.854-0.001,25.832-0.001,35.687,0l80.596,0.003c39.419,0.001,55.397,24.945,35.688,55.715l-40.294,62.911c-4.928,7.692-12.916,20.163-17.844,27.855l-40.301,62.908c-19.711,30.768-51.667,30.768-71.378,0l-40.301-62.908c-4.928-7.692-12.916-20.163-17.844-27.855L854.339,356.152z",
        THROAT: "M1105.542,807.801c-0.001,29.746-22.378,53.859-49.982,53.86l-47.721,0.001c-11.042,0.001-28.943,0.001-39.984,0l-47.721-0.001c-27.604-0.001-49.981-24.114-49.982-53.86l-0.001-51.422c-0.001-11.898-0.001-31.188,0-43.087l0.001-51.423c0.001-29.745,22.378-53.858,49.982-53.859l47.721-0.001c11.041-0.001,28.942-0.001,39.984,0l47.721,0.001c27.604,0.001,49.981,24.114,49.982,53.859l0.001,51.423c0.001,11.898,0.001,31.188,0,43.087L1105.542,807.801z",
        G: "M1023.042,1203.557c-19.519,19.518-51.165,19.517-70.685-0.002l-33.744-33.743c-7.808-7.808-20.466-20.466-28.273-28.273l-33.742-33.745c-19.519-19.521-19.519-51.167-0.001-70.686l33.742-33.744c7.807-7.807,20.465-20.465,28.272-28.272l33.744-33.741c19.519-19.519,51.164-19.518,70.684,0.001l33.745,33.743c7.808,7.808,20.466,20.466,28.272,28.274l33.743,33.745c19.519,19.52,19.519,51.166,0.001,70.685l-33.742,33.744c-7.807,7.808-20.465,20.466-28.272,28.272L1023.042,1203.557z",
        EGO: "M1364.791,1286.496c11.264,24.11-3.228,39.686-32.368,34.789l-60.875-10.229c-7.377-1.239-19.338-3.25-26.715-4.49l-61.13-10.276c-29.14-4.898-38.271-24.444-20.396-43.657l37.34-40.135c4.525-4.864,11.862-12.75,16.389-17.613l37.5-40.302c17.877-19.211,41.501-15.241,52.767,8.868l23.534,50.365c2.852,6.104,7.476,15.999,10.327,22.104L1364.791,1286.496z",
        SACRAL: "M1105.542,1585.162c-0.001,27.972-22.378,50.647-49.982,50.648l-47.721,0.001c-11.042,0.001-28.943,0.001-39.984,0l-47.721-0.001c-27.604-0.001-49.981-22.677-49.982-50.648l-0.001-48.356c-0.001-11.189-0.001-29.329,0-40.518l0.001-48.356c0.001-27.973,22.378-50.648,49.982-50.648l47.721-0.002c11.041,0,28.942,0,39.984,0l47.721,0.002c27.604,0,49.981,22.676,49.982,50.648l0.001,48.356c0.001,11.188,0.001,29.328,0,40.518L1105.542,1585.162z",
        ROOT: "M1105.542,1903.162c-0.001,27.972-22.378,50.647-49.982,50.648l-47.721,0.001c-11.042,0.001-28.943,0.001-39.984,0l-47.721-0.001c-27.604-0.001-49.981-22.677-49.982-50.648l-0.001-48.356c-0.001-11.189-0.001-29.329,0-40.518l0.001-48.356c0.001-27.973,22.378-50.648,49.982-50.648l47.721-0.002c11.041,0,28.942,0,39.984,0l47.721,0.002c27.604,0,49.981,22.676,49.982,50.648l0.001,48.356c0.001,11.188,0.001,29.328,0,40.518L1105.542,1903.162z",
        SPLEEN: "M466.328,1362.758c-30.77-19.708-55.713-3.729-55.715,35.689l-0.003,80.596c0,9.854,0,25.832,0,35.687l0.003,80.595c0.001,39.419,24.945,55.397,55.715,35.689l62.911-40.295c7.692-4.927,20.164-12.915,27.855-17.843l62.908-40.301c30.768-19.711,30.768-51.668,0-71.379l-62.908-40.3c-7.692-4.928-20.163-12.917-27.855-17.844L466.328,1362.758z",
        SOLAR: "M1509.455,1362.758c30.77-19.708,55.714-3.729,55.715,35.689l0.003,80.596c0.001,9.854,0.001,25.832,0,35.687l-0.003,80.595c-0.001,39.419-24.945,55.397-55.715,35.689l-62.911-40.295c-7.692-4.927-20.163-12.915-27.855-17.843l-62.908-40.301c-30.768-19.711-30.768-51.668,0-71.379l62.908-40.3c7.692-4.928,20.163-12.917,27.855-17.844L1509.455,1362.758z"
    },
    GATE_COORDS: {
        64: { x: 920, y: 210 }, 61: { x: 990, y: 210 }, 63: { x: 1050, y: 210 },
        47: { x: 920, y: 340 }, 24: { x: 990, y: 340 }, 4: { x: 1060, y: 340 },
        17: { x: 935, y: 430 }, 11: { x: 1045, y: 430 }, 43: { x: 990, y: 495 },
        62: { x: 920, y: 647 }, 23: { x: 990, y: 647 }, 56: { x: 1060, y: 647 },
        16: { x: 900, y: 710 }, 35: { x: 1080, y: 700 }, 20: { x: 900, y: 757 },
        12: { x: 1080, y: 747 }, 45: { x: 1080, y: 797 }, 31: { x: 920, y: 847 },
        8: { x: 990, y: 847 }, 33: { x: 1060, y: 847 }, 1: { x: 990, y: 950 },
        7: { x: 920, y: 1010 }, 13: { x: 1060, y: 1010 }, 10: { x: 850, y: 1080 },
        25: { x: 1130, y: 1080 }, 15: { x: 920, y: 1150 }, 46: { x: 1060, y: 1150 },
        2: { x: 990, y: 1180 }, 21: { x: 1280, y: 1150 }, 51: { x: 1220, y: 1210 },
        26: { x: 1170, y: 1270 }, 40: { x: 1350, y: 1310 }, 5: { x: 920, y: 1425 },
        14: { x: 990, y: 1425 }, 29: { x: 1060, y: 1425 }, 34: { x: 900, y: 1475 },
        27: { x: 900, y: 1535 }, 59: { x: 1080, y: 1535 }, 42: { x: 920, y: 1595 },
        3: { x: 990, y: 1595 }, 9: { x: 1060, y: 1595 }, 53: { x: 920, y: 1750 },
        60: { x: 990, y: 1750 }, 52: { x: 1060, y: 1750 }, 54: { x: 900, y: 1810 },
        19: { x: 1080, y: 1810 }, 38: { x: 900, y: 1870 }, 39: { x: 1080, y: 1870 },
        58: { x: 900, y: 1930 }, 41: { x: 1080, y: 1930 }, 48: { x: 430, y: 1360 },
        57: { x: 480, y: 1400 }, 44: { x: 540, y: 1440 }, 50: { x: 620, y: 1500 },
        32: { x: 540, y: 1560 }, 28: { x: 480, y: 1600 }, 18: { x: 430, y: 1630 },
        36: { x: 1540, y: 1360 }, 22: { x: 1480, y: 1400 }, 37: { x: 1420, y: 1440 },
        6: { x: 1340, y: 1500 }, 49: { x: 1420, y: 1540 }, 55: { x: 1480, y: 1580 },
        30: { x: 1540, y: 1620 }
    },
    CHANNEL_PATHS: {
        '64-47': 'M 990 250 L 990 300', '61-24': 'M 1006 250 L 1006 300',
        '63-4': 'M 1022 250 L 1022 300', '17-62': 'M 930 480 L 930 608',
        '43-23': 'M 1006 510 L 1006 608', '11-56': 'M 1080 480 L 1080 608',
        '16-48': 'M 870 735 Q 650 900 550 1328', '31-7': 'M 960 862 L 960 1020',
        '8-1': 'M 1006 862 L 1006 1020', '33-13': 'M 1052 862 L 1052 1020',
        '35-36': 'M 1106 735 Q 1350 900 1520 1328', '12-22': 'M 1090 770 Q 1300 900 1510 1400',
        '10-34': 'M 900 1130 Q 880 1300 920 1446', '20-57': 'M 900 1130 Q 700 1250 490 1400',
        '15-5': 'M 970 1150 L 970 1446', '2-14': 'M 1006 1185 L 1006 1446',
        '46-29': 'M 1042 1150 L 1042 1446', '42-53': 'M 970 1610 L 970 1765',
        '3-60': 'M 1006 1580 L 1006 1765', '9-52': 'M 1042 1610 L 1042 1765'
    }
};

const DetailCard = ({ title, subtitle, icon, content, color }) => (
    <motion.div
        initial={{ opacity: 0, scale: 0.98 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white border border-gray-100 rounded-[2.5rem] p-8 shadow-sm hover:shadow-md transition-all group"
    >
        <div className="flex items-center gap-5 mb-5">
            <div className={`w-14 h-14 ${color} rounded-[1.25rem] flex items-center justify-center text-2xl shadow-inner group-hover:scale-110 transition-transform`}>
                {icon}
            </div>
            <div className="flex flex-col">
                <span className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em]">{title}</span>
                <h5 className="text-xl font-black text-gray-900 tracking-tight leading-none mt-1">{subtitle}</h5>
            </div>
        </div>
        <p className="text-gray-500 text-sm leading-relaxed font-medium">
            {content}
        </p>
    </motion.div>
);

const HumanDesign = ({ id: propId, moduleId }) => {
    const { id: routeId } = useParams();
    const id = routeId || propId;
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [isCalculating, setIsCalculating] = useState(false);
    const [calcProgress, setCalcProgress] = useState(0);
    const [packageData, setPackageData] = useState(null);
    const [chartData, setChartData] = useState(null);
    const [isHeaderExpanded, setIsHeaderExpanded] = useState(false);
    const [activeTab, setActiveTab] = useState("ozet");

    const TABS = [
        { id: "ozet", label: "Özet" },
        { id: "harita", label: "Harita" },
        { id: "detay", label: "Analiz" }
    ];

    useEffect(() => {
        if (!id) return;
        const initData = async () => {
            try {
                const pkg = await getCurrentPackageUserModule(id, 13);
                setPackageData(pkg);
                const latest = await getLatestHumanChart();
                if (latest && latest.success && latest.data) {
                    setChartData(latest.data);
                }
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        initData();
    }, [id]);

    const handleCalculate = async () => {
        setIsCalculating(true);
        setCalcProgress(0);
        const timer = setInterval(() => {
            setCalcProgress(prev => (prev >= 95 ? 95 : prev + 1.25));
        }, 100);
        try {
            const response = await calculateHumanChart();
            if (response && response.success) {
                setCalcProgress(100);
                setTimeout(() => {
                    setChartData(response.data);
                    setIsCalculating(false);
                }, 1000);
            } else {
                clearInterval(timer);
                setIsCalculating(false);
            }
        } catch (err) {
            clearInterval(timer);
            setIsCalculating(false);
        }
    };

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };

    const [isSharing, setIsSharing] = useState(false);

    const handleShare = async () => {
        if (isSharing) return;
        setIsSharing(true);

        let toastId;
        try {
            toastId = toast.loading("Raporunuz hazırlanıyor...");
        } catch (e) {
            console.warn("Toast error, using console only");
        }

        try {
            const printableElement = document.getElementById("hd-printable-area");
            if (!printableElement) throw new Error("Yazdırılabilir alan bulunamadı");

            // Temporary show the element to capture
            printableElement.style.display = "block";
            printableElement.style.position = "fixed";
            printableElement.style.left = "0";
            printableElement.style.top = "0";
            printableElement.style.zIndex = "-100";
            printableElement.style.width = "500px";
            printableElement.style.visibility = "visible";

            // Calculate height while it's visible
            const elementHeight = printableElement.scrollHeight;
            const pdfWidth = 500;
            const pdfHeight = (elementHeight * pdfWidth) / printableElement.offsetWidth;

            const dataUrl = await domtoimage.toJpeg(printableElement, {
                quality: 0.98,
                bgcolor: "#ffffff",
                width: 500,
                height: elementHeight,
                style: {
                    display: 'block',
                    visibility: 'visible',
                    position: 'static'
                }
            });

            printableElement.style.display = "none";

            const pdf = new jsPDF({
                orientation: "portrait",
                unit: "px",
                format: [500, pdfHeight]
            });

            pdf.addImage(dataUrl, "JPEG", 0, 0, 500, pdfHeight);

            const pdfBlob = pdf.output("blob");
            const fileName = `Jodiac-Human-Design-${new Date().getTime()}.pdf`;
            const file = new File([pdfBlob], fileName, { type: "application/pdf" });

            const shareData = {
                title: "Human Design Haritam",
                text: "Jodiac ile Human Design Haritamı hesapladım. Sence de çok güzel değil mi?",
                files: [file]
            };

            if (navigator.share && navigator.canShare && navigator.canShare(shareData)) {
                try {
                    await navigator.share(shareData);
                    if (toastId) toast.update(toastId, { render: "Başarıyla paylaşıldı!", type: "success", isLoading: false, autoClose: 3000 });
                } catch (shareErr) {
                    if (shareErr.name !== 'AbortError') {
                        pdf.save(fileName);
                        if (toastId) toast.update(toastId, { render: "Paylaşım iptal edildi, PDF indirildi.", type: "info", isLoading: false, autoClose: 3000 });
                    } else {
                        if (toastId) toast.dismiss(toastId);
                    }
                }
            } else {
                pdf.save(fileName);
                if (toastId) toast.update(toastId, { render: "PDF başarıyla indirildi!", type: "success", isLoading: false, autoClose: 3000 });
            }
        } catch (err) {
            console.error("Share error:", err);
            if (toastId) toast.update(toastId, { render: "Rapor oluşturulurken bir hata oluştu.", type: "error", isLoading: false, autoClose: 3000 });
            else alert("Rapor oluşturulurken bir hata oluştu.");
        } finally {
            setIsSharing(false);
        }
    };

    if (loading || !packageData) {
        return (
            <div className="w-full h-screen min-h-screen flex items-center justify-center bg-[#e8e9ed]">
                <div className="flex flex-col items-center justify-center">
                    <div className="relative mb-8">
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="animate-spin rounded-full h-24 w-24 border-4 border-transparent border-t-[#3DA7B5] border-r-[#3DA7B5] opacity-75"></div>
                        </div>
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="animate-spin rounded-full h-16 w-16 border-[3px] border-transparent border-b-[#2a8a96] border-l-[#2a8a96] opacity-60" style={{ animationDirection: "reverse", animationDuration: "1.5s" }}></div>
                        </div>
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="h-12 w-12 rounded-full bg-gradient-to-br from-[#3DA7B5] via-[#2a8a96] to-[#3DA7B5] animate-pulse shadow-2xl"></div>
                        </div>
                    </div>
                    <p className="text-xl font-semibold text-gray-800 animate-pulse">Yükleniyor...</p>
                </div>
            </div>
        );
    }

    const blueprint = chartData?.energy_blueprint;

    return (
        <div className="w-full h-screen min-h-screen flex items-stretch justify-stretch sm:items-center sm:justify-center bg-[#e8e9ed] relative">
            <div className="flex flex-col items-center w-full min-h-full bg-white shadow-xl border border-gray-200 rounded-none sm:max-w-[390px] sm:h-[700px] sm:rounded-3xl relative overflow-y-auto">
                {/* ModuleHeader */}
                {packageData && (
                    <div className="relative z-30 w-full mb-2">
                        <ModuleHeader
                            userName={packageData.user?.first_name + " " + packageData.user?.last_name}
                            subtitle={packageData.package?.name + " Modülüne Hoş Geldiniz"}
                            title={packageData.package?.name}
                            description={packageData.package?.description}
                            backgroundImage={packageData.package?.image_url}
                            onExpandedChange={setIsHeaderExpanded}
                            showToggle={true}
                            autoHeight={true}
                        />
                    </div>
                )}

                <div className="min-h-screen bg-white w-full px-6 py-4">
                    {/* Tab Navigation */}
                    {chartData && !isCalculating && (
                        <div className="bg-gray-100/60 p-1 rounded-full flex items-center relative gap-1 mb-6">
                            {TABS.map((tab) => {
                                const isActive = activeTab === tab.id;
                                return (
                                    <button
                                        key={tab.id}
                                        onClick={() => handleTabClick(tab.id)}
                                        className={`relative flex-1 py-2.5 rounded-full text-[10px] font-black transition-all duration-500 ${isActive ? "text-white" : "text-gray-400"}`}
                                    >
                                        {isActive && (
                                            <motion.div
                                                layoutId="hdTabPremiumLight"
                                                className="absolute inset-0 bg-[#3DA7B5] rounded-full shadow-lg shadow-[#3DA7B5]/20"
                                                transition={{ type: "spring", duration: 0.6 }}
                                            />
                                        )}
                                        <span className="relative z-10">{tab.label}</span>
                                    </button>
                                );
                            })}
                        </div>
                    )}

                    <AnimatePresence mode="wait">
                        {isCalculating && (
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -20 }}
                                className="flex flex-col items-center justify-center py-20"
                            >
                                <div className="relative mb-6">
                                    <div className="w-24 h-24 rounded-full border-4 border-gray-100 flex items-center justify-center">
                                        <motion.div
                                            animate={{ rotate: 360 }}
                                            transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
                                            className="w-20 h-20 rounded-full border-4 border-transparent border-t-[#3DA7B5] border-r-[#3DA7B5]"
                                        />
                                    </div>
                                    <div className="absolute inset-0 flex items-center justify-center">
                                        <span className="text-lg font-black text-[#3DA7B5]">{Math.round(calcProgress)}%</span>
                                    </div>
                                </div>
                                <h3 className="text-xl font-black text-gray-800 mb-2 text-center">Haritanız Hesaplanıyor</h3>
                                <p className="text-sm text-gray-500 text-center max-w-xs">
                                    Genetik enerji haritanız hazırlanıyor, lütfen bekleyiniz...
                                </p>
                            </motion.div>
                        )}

                        {!chartData && !isCalculating && (
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                className="flex flex-col items-center justify-center py-16"
                            >
                                <div className="w-24 h-24 bg-gradient-to-br from-[#3DA7B5]/10 to-[#3DA7B5]/5 rounded-full flex items-center justify-center mb-6">
                                    <FiActivity className="text-4xl text-[#3DA7B5]" />
                                </div>
                                <h3 className="text-xl font-black text-gray-800 mb-2 text-center">Human Design Haritanız</h3>
                                <p className="text-sm text-gray-500 text-center max-w-xs mb-8">
                                    Genetik enerji haritanızı hesaplayarak benzersiz tasarımınızı keşfedin.
                                </p>
                                <button
                                    onClick={handleCalculate}
                                    className="px-8 py-4 bg-gradient-to-r from-[#3DA7B5] to-[#5ABCC8] text-white font-black rounded-full shadow-lg shadow-[#3DA7B5]/30 hover:shadow-xl hover:scale-105 transition-all"
                                >
                                    Haritamı Hesapla
                                </button>
                            </motion.div>
                        )}

                        {chartData && !isCalculating && (
                            <motion.div
                                key={activeTab}
                                initial={{ opacity: 0, x: 20 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: -20 }}
                                transition={{ duration: 0.3 }}
                                className="w-full"
                            >
                                {activeTab === "ozet" && (
                                    <div className="space-y-6 pb-12">
                                        <div className="bg-gradient-to-br from-[#3DA7B5] to-[#5ABCC8] p-10 rounded-[3rem] text-white shadow-xl shadow-[#3DA7B5]/10 text-center relative overflow-hidden">
                                            <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16 blur-2xl" />
                                            <span className="text-[10px] font-black text-white/70 uppercase tracking-[0.3em] mb-3 block">DENGELİ ENERJİ TİPİNİZ</span>
                                            <h2 className="text-3xl font-black mb-6 tracking-tight leading-tight uppercase">{blueprint?.type?.name}</h2>
                                            <div className="px-4 py-3 bg-white/10 rounded-2xl backdrop-blur-sm">
                                                <p className="text-white text-xs leading-relaxed font-bold italic">"{blueprint?.type?.description_short || blueprint?.type?.description}"</p>
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-2 gap-4">
                                            <div className="bg-white p-7 rounded-[2.5rem] border border-gray-100 shadow-sm space-y-3">
                                                <div className="w-10 h-10 bg-emerald-50 rounded-2xl flex items-center justify-center text-emerald-500">
                                                    <FiTarget />
                                                </div>
                                                <div>
                                                    <span className="text-[9px] font-black text-gray-400 uppercase tracking-widest block mb-1">Strateji</span>
                                                    <p className="text-[13px] font-black text-gray-800 leading-tight">{typeof blueprint?.strategy === 'string' ? blueprint.strategy : blueprint?.strategy?.name}</p>
                                                </div>
                                            </div>
                                            <div className="bg-white p-7 rounded-[2.5rem] border border-gray-100 shadow-sm space-y-3">
                                                <div className="w-10 h-10 bg-amber-50 rounded-2xl flex items-center justify-center text-amber-500">
                                                    <FiCpu />
                                                </div>
                                                <div>
                                                    <span className="text-[9px] font-black text-gray-400 uppercase tracking-widest block mb-1">Otorite</span>
                                                    <p className="text-[13px] font-black text-[#3DA7B5] leading-tight">{blueprint?.authority?.name}</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="bg-[#f8fafc] border border-gray-100 rounded-[2.5rem] p-8 space-y-3">
                                            <div className="flex items-center gap-3">
                                                <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-sm">
                                                    <FiUser className="text-purple-500" />
                                                </div>
                                                <span className="text-xs font-black text-gray-800 uppercase tracking-widest">Enkarnasyon Haçı</span>
                                            </div>
                                            <p className="text-xs text-gray-500 font-medium leading-relaxed">{blueprint?.incarnation_cross}</p>
                                        </div>

                                        <DetailCard title="İçsel Otorite" subtitle={blueprint?.authority?.name} icon={<FiCpu />} content="" color="bg-cyan-50 text-cyan-500" />
                                        <DetailCard title="Profil" subtitle={blueprint?.profile?.name?.split(' – ')[0]} icon={<FiUser />} content="" color="bg-purple-50 text-purple-600" />

                                        <div className="bg-gray-900 rounded-[2.5rem] p-10 text-white relative overflow-hidden shadow-2xl">
                                            <div className="absolute top-0 right-0 p-16 bg-[#3DA7B5]/20 rounded-full blur-3xl -mr-10 -mt-10" />
                                            <h5 className="font-black text-lg text-white mb-6 relative z-10 flex items-center gap-3">
                                                <FiTarget className="text-[#3DA7B5]" /> Potansiyel Alanlar
                                            </h5>
                                            <div className="flex flex-wrap gap-2 relative z-10">
                                                {blueprint?.centers?.open?.map(c => (
                                                    <span key={c} className="text-[10px] font-bold bg-white/10 border border-white/5 px-4 py-2.5 rounded-2xl text-white/80 uppercase tracking-widest">{c === 'SolarPlexus' || c === 'Solar Plexus' ? 'Solar P.' : c}</span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {activeTab === "harita" && (
                                    <HumanDesignMap
                                        chartData={chartData}
                                        packageData={packageData}
                                        embedded={true}
                                    />
                                )}

                                {activeTab === "detay" && (
                                    <HumanDesignAnalysis
                                        chartData={chartData}
                                        packageData={packageData}
                                        embedded={true}
                                    />
                                )}
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
            </div>

            <div id="hd-printable-area" style={{ display: "none", backgroundColor: "#ffffff", color: "#1f2937", width: "500px", fontFamily: "sans-serif" }}>
                <div style={{ backgroundColor: "#ffffff", padding: "40px", display: "flex", flexDirection: "column", gap: "40px" }}>
                    {/* Header */}
                    <div style={{
                        background: "linear-gradient(135deg, #1e293b 0%, #334155 100%)",
                        padding: "60px 40px",
                        borderRadius: "56px",
                        color: "#ffffff",
                        textAlign: "center",
                        boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)"
                    }}>
                        <div style={{ marginBottom: "24px", opacity: "0.6", letterSpacing: "0.6em", fontWeight: "900", fontSize: "14px" }}>JODIAC HUMAN DESIGN</div>
                        <h1 style={{ fontSize: "40px", fontWeight: "900", marginBottom: "8px", textTransform: "uppercase", letterSpacing: "-0.02em" }}>{blueprint?.type?.name}</h1>
                        <div style={{ height: "4px", width: "80px", background: "#3DA7B5", margin: "24px auto" }} />
                        <p style={{ fontSize: "14px", fontWeight: "500", opacity: "0.9", lineHeight: "1.8", maxWidth: "380px", margin: "0 auto" }}>
                            {blueprint?.type?.description_short || blueprint?.type?.description}
                        </p>
                    </div>

                    {/* Summary Cards */}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                        {[
                            { label: 'Strateji', val: typeof blueprint?.strategy === 'string' ? blueprint.strategy : blueprint?.strategy?.name, color: '#0ea5e9' },
                            { label: 'Otorite', val: blueprint?.authority?.name, color: '#3DA7B5' },
                            { label: 'Profil', val: blueprint?.profile?.name?.split(' – ')[0], color: '#9333ea' },
                            { label: 'Enkarnasyon Haçı', val: blueprint?.incarnation_cross, color: '#f59e0b' }
                        ].map((stat, i) => (
                            <div key={i} style={{ backgroundColor: "#f8fafc", padding: "28px", borderRadius: "40px", border: "1px solid #f1f5f9" }}>
                                <span style={{ fontSize: "10px", fontWeight: "900", color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.15em", display: "block", marginBottom: "8px" }}>{stat.label}</span>
                                <p style={{ fontSize: "15px", fontWeight: "900", color: stat.color, lineHeight: "1.3" }}>{stat.val}</p>
                            </div>
                        ))}
                    </div>

                    {/* Bodygraph Map */}
                    <div style={{ backgroundColor: "#ffffff", borderRadius: "56px", padding: "40px", border: "1px solid #f1f5f9", textAlign: "center" }}>
                        <h3 style={{ fontSize: "20px", fontWeight: "900", marginBottom: "40px", color: "#1e293b", letterSpacing: "-0.02em" }}>Enerji Haritanız (Bodygraph)</h3>
                        <div style={{ width: "100%", maxWidth: "420px", margin: "0 auto" }}>
                            <svg viewBox="0 0 2000 2000" style={{ width: "100%", height: "auto" }}>
                                <path d={MAP_DATA.SVG_PATHS.FIGURE} fill="#f1f5f9" />
                                <g>
                                    {Object.entries(MAP_DATA.SVG_PATHS).map(([key, path]) => {
                                        if (key === 'FIGURE') return null;
                                        const isDefined = blueprint?.centers?.defined?.includes(key.charAt(0) + key.slice(1).toLowerCase()) || (key === 'SOLAR' && blueprint?.centers?.defined?.some(d => d.includes('Solar')));
                                        return <path key={key} d={path} fill={isDefined ? MAP_DATA.COLORS[key] : '#ffffff'} stroke="#cbd5e1" strokeWidth="4" />;
                                    })}
                                </g>
                                <g>
                                    {Object.entries(MAP_DATA.CHANNEL_PATHS).map(([id, path]) => {
                                        const [g1, g2] = id.split('-').map(Number);
                                        const isP1 = blueprint?.personality_activations?.some(a => a.gate === g1);
                                        const isD1 = blueprint?.design_activations?.some(a => a.gate === g1);
                                        const isP2 = blueprint?.personality_activations?.some(a => a.gate === g2);
                                        const isD2 = blueprint?.design_activations?.some(a => a.gate === g2);

                                        if ((isP1 || isD1) && (isP2 || isD2)) {
                                            return <path key={id} d={path} fill="none" stroke="#3DA7B5" strokeWidth="25" strokeLinecap="round" opacity="0.8" />;
                                        }
                                        return null;
                                    })}
                                </g>
                                <g>
                                    {Object.entries(MAP_DATA.GATE_COORDS).map(([nr, { x, y }]) => {
                                        const isActive = blueprint?.personality_activations?.some(a => a.gate === Number(nr)) || blueprint?.design_activations?.some(a => a.gate === Number(nr));
                                        if (!isActive) return null;
                                        return <circle key={nr} cx={x} cy={y} r="32" fill="#ffffff" stroke="#1e293b" strokeWidth="4" />;
                                    })}
                                    {Object.entries(MAP_DATA.GATE_COORDS).map(([nr, { x, y }]) => (
                                        <text key={nr + "t"} x={x} y={y + 12} textAnchor="middle" fontSize="36" fontWeight="900" fill="#1e293b">{nr}</text>
                                    ))}
                                </g>
                            </svg>
                        </div>
                    </div>

                    {/* Activations Section */}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px" }}>
                        <div style={{ backgroundColor: "#fff1f2", padding: "32px", borderRadius: "48px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
                                <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#e11d48" }} />
                                <span style={{ fontSize: "11px", fontWeight: "900", color: "#e11d48", letterSpacing: "0.2em" }}>TASARIM</span>
                            </div>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                                {blueprint?.design_activations?.slice(0, 10).map((a, i) => (
                                    <div key={i} style={{ background: "#ffffff", padding: "8px 12px", borderRadius: "14px", fontSize: "11px", fontWeight: "900", color: "#e11d48", border: "1px solid rgba(225,29,72,0.1)" }}>
                                        {PLANET_SYMBOLS[a.planet] || '•'} {a.gate}.{a.line}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div style={{ backgroundColor: "#ecfeff", padding: "32px", borderRadius: "48px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "20px", justifyContent: "flex-end" }}>
                                <span style={{ fontSize: "11px", fontWeight: "900", color: "#0891b2", letterSpacing: "0.2em" }}>KİŞİLİK</span>
                                <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#0891b2" }} />
                            </div>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", justifyContent: "flex-end" }}>
                                {blueprint?.personality_activations?.slice(0, 10).map((a, i) => (
                                    <div key={i} style={{ background: "#ffffff", padding: "8px 12px", borderRadius: "14px", fontSize: "11px", fontWeight: "900", color: "#0891b2", border: "1px solid rgba(8,145,178,0.1)" }}>
                                        {PLANET_SYMBOLS[a.planet] || '•'} {a.gate}.{a.line}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Report Sections */}
                    {blueprint?.report && (
                        <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
                            <div style={{ backgroundColor: "#ffffff", padding: "40px", borderRadius: "48px", border: "1px solid #f1f5f9" }}>
                                <h4 style={{ fontSize: "18px", fontWeight: "900", marginBottom: "16px", color: "#1e293b" }}>Genel Analiz</h4>
                                <p style={{ fontSize: "14px", color: "#64748b", lineHeight: "1.8", fontWeight: "500" }}>{blueprint.report.general_personality}</p>
                            </div>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "16px" }}>
                                {[
                                    { t: 'Hayat Teması', v: blueprint.report.life_theme, c: '#f97316' },
                                    { t: 'Kariyer', v: blueprint.report.work_and_career, c: '#3b82f6' },
                                    { t: 'İlişkiler', v: blueprint.report.relationships, c: '#e11d48' },
                                    { t: 'Gelişim Yolu', v: blueprint.report.growth_path, c: '#10b981' }
                                ].map((item, i) => (
                                    <div key={i} style={{ backgroundColor: "#ffffff", padding: "32px", borderRadius: "40px", border: "1px solid #f1f5f9" }}>
                                        <h5 style={{ fontSize: "12px", fontWeight: "900", color: item.c, textTransform: "uppercase", marginBottom: "8px", letterSpacing: "0.1em" }}>{item.t}</h5>
                                        <p style={{ fontSize: "14px", color: "#475569", lineHeight: "1.6", fontWeight: "500" }}>{item.v}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Meslekler */}
                    <div style={{ backgroundColor: "#1e293b", borderRadius: "56px", padding: "48px", color: "#ffffff" }}>
                        <h5 style={{ fontWeight: "900", fontSize: "22px", marginBottom: "32px", letterSpacing: "-0.02em" }}>Kariyer Potansiyelleri</h5>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                            {blueprint?.type?.career_suggestions?.map((tip, i) => (
                                <div key={i} style={{ backgroundColor: "rgba(255,255,255,0.05)", borderRadius: "24px", padding: "20px", border: "1px solid rgba(255,255,255,0.1)" }}>
                                    <div style={{ color: "#3DA7B5", fontWeight: "900", fontSize: "12px", marginBottom: "8px" }}>0{i + 1}</div>
                                    <p style={{ fontSize: "13px", fontWeight: "500", opacity: "0.9" }}>{tip}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Footer */}
                    <div style={{ textAlign: "center", paddingTop: "20px", borderTop: "1px solid #f1f5f9" }}>
                        <div style={{ fontSize: "16px", fontWeight: "900", color: "#3DA7B5", marginBottom: "4px" }}>JODIAC</div>
                        <p style={{ fontSize: "11px", fontWeight: "700", color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.2em" }}>Cebindeki Rehberin</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HumanDesign;
